import { CLIENT_FLAG } from '../constants';
const IOS_UA_REG = /(iPhone|iPad|iPod|iOS)/i;
const ANDROID_UA_REG = /Android/i;
/**
 * 获取客户端标志位
 * @returns 客户端标志位
 */
export const getClientFlag = () => {
    const userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent;
    if (IOS_UA_REG.test(userAgent)) {
        return CLIENT_FLAG.IOS;
    }
    if (ANDROID_UA_REG.test(userAgent)) {
        return CLIENT_FLAG.ANDROID;
    }
    return CLIENT_FLAG.PC;
};
